import React from 'react';
import CircleGraph from '../../CircleGraph/CircleGraph';
import './CreditUsageCircleGraph.scss';

const colorConfig = {
  high: 'red3',
  moderateHigh: 'orange2',
  moderate: 'yellow2',
  good: 'lgreen3',
  great: 'green3',
  na: 'gray',
};

export function getUsageStrokeColor(usage) {
  if (isNaN(usage)) {
    return colorConfig.na;
  } else if (usage <= 10) {
    return colorConfig.great;
  } else if (usage >= 11 && usage <= 30) {
    return colorConfig.good;
  } else if (usage >= 31 && usage <= 50) {
    return colorConfig.moderate;
  } else if (usage >= 51 && usage <= 70) {
    return colorConfig.moderateHigh;
  } else {
    return colorConfig.high;
  }
}

function CreditUsageCircleGraph(props) {
  const datatestid = props.datatestid ? props.datatestid : null;
  const usageFill = props.usage;
  const percentageSign = props.usage === 'N/A' ? '' : '%';
  const strokeWidth = props?.strokeWidth ?? 6;

  const titleText = props.isNewCredit
    ? `--`
    : `${usageFill > 200 ? '>200' : usageFill}${percentageSign}`;

  const isOverLimit = props.usage > 100 ? true : false;
  const strokeFill = getUsageStrokeColor(usageFill);

  return (
    <div
      data-testid={datatestid}
      className={`creditUsageCircleGraph-container`}
    >
      {isOverLimit && (
        <CircleGraph
          doubleGraph
          strokeFill={strokeFill}
          datatestid={`${datatestid}-outer`}
          strokeWidth={3}
          width={263}
          mobileWidth={156}
          percent={usageFill - 100}
        />
      )}
      <CircleGraph
        datatestid={`${datatestid}`}
        percent={usageFill}
        strokeWidth={strokeWidth}
        width={props.width}
        mobileWidth={props.mobileWidth}
        titleText={titleText}
        subTitleText={props.subTitleText}
        strokeFill={strokeFill}
        pageType={props.pageType}
      />
    </div>
  );
}

CreditUsageCircleGraph.defaultProps = {
  subTitleText: 'Usage',
};

export default CreditUsageCircleGraph;
